import { SdbMemberTypes } from "@custom-types/member-types";
import { useHasUserValidRoleCompanyLevel } from "@hooks/access-control/use-has-user-valid-role-company-level";
import { useAppParams } from "@router/router-helper";
import { companyMembersSelector } from "@store/members/members-selector";
import { fetchCompanyMembers } from "@store/members/members-slice-thunk";
import { useAppDispatch, useAppSelector } from "@store/store-helper";
import { fetchTeams } from "@store/teams/teams-slice-thunk";
import { useEffect } from "react";

/** Returns all the members in the company */
export function useCompanyMembers(): SdbMemberTypes[] {
  const { companyId } = useAppParams();
  const dispatch = useAppDispatch();
  const companyMembers = useAppSelector(companyMembersSelector);
  const { canFetchTeams } = useHasUserValidRoleCompanyLevel();

  // Fetch all the members in the company
  useEffect(() => {
    async function fetchCompanyMembersViaStore(): Promise<void> {
      if (companyId) {
        await dispatch(
          fetchCompanyMembers({
            companyId,
          })
        );
      }

      canFetchTeams && (await dispatch(fetchTeams({})));
    }
    void fetchCompanyMembersViaStore();
  }, [canFetchTeams, companyId, dispatch]);

  return companyMembers;
}
